import { useFilters } from 'hooks/useFilter'
import { ListRequestParams } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import APageWrapper from 'views/components/PageWrapper/APageWrapper'
import ATableFullPage from 'views/components/Table/ATableFullPage'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import * as Layout from 'views/layouts/NewLayout'
import * as Header from 'views/ui/Header/Header'
import { useColumns } from './Columns/useColumns'
import DocIndexFilters from './DocIndexFilters'

export const DocindexList: FC = () => {
  const { t } = useTranslation('documents')
  const [listRequestParams, setListRequestParams] = useState<ListRequestParams>(defaultListRequestParams)
  const { isFiltersLoaded, updateFilterState } = useFilters({
    listRequestParams,
    setListRequestParams,
  })

  const columns = useColumns()

  return (
    <APageWrapper page="DocIndex" place="DocIndex">
      <Layout.WrapperContent>
        <Layout.Header>
          <Layout.TopHeader>
            <Header.Breadcrumbs routes={[{ breadcrumbName: t('documentsIndex') }]} />
          </Layout.TopHeader>
          <Layout.PageName>{t('documentsIndex')}</Layout.PageName>
          <DocIndexFilters
            updateFilterState={updateFilterState}
            listRequestParams={listRequestParams}
            setListRequestParams={setListRequestParams}
          />
        </Layout.Header>

        <ATableFullPage
          listParamsUpdated={setListRequestParams}
          listRequestParams={listRequestParams}
          dataEndpoint={endpoints.documentIndex()}
          isFiltersLoaded={isFiltersLoaded}
          columns={columns}
          rowHoverGray
        />
      </Layout.WrapperContent>
    </APageWrapper>
  )
}
